import { useTaskNotifications } from '../hooks/useTaskNotifications';

/**
 * Komponente für Aufgaben-Benachrichtigungen
 * Wird in das Layout eingebunden und läuft im Hintergrund
 */
const TaskNotificationProvider = () => {
  // Hook aktivieren - das Polling läuft automatisch
  useTaskNotifications();
  
  // Diese Komponente rendert nichts sichtbares
  return null;
};

export default TaskNotificationProvider;
